const WALLET_NAME_MAP: Record<string, string> = {
	google: 'Continue with Google',
	apple: 'Apple',
	petra: 'Petra',
	/*martian: 'Martian',
	pontem: 'Pontem',
	fewcha: 'Fewcha',
	rise: 'Rise Wallet',
	okx: 'OKX Wallet',
	blocto: 'Blocto',
	bitkeep: 'BitKeep Wallet',
	msafe: 'MSafe',
	nightly: 'Nightly',
	shopify: 'Shopify Wallet',
	suiet: 'Suiet',*/
};

const normalize = (value?: string | null) => value?.toLowerCase().trim() ?? '';

export const canonicalWalletName = (value?: string | null) => {
	const normalized = normalize(value);
	if (!normalized) {
		return '';
	}

	const entry = Object.entries(WALLET_NAME_MAP).find(([key]) =>
		normalized.includes(key),
	);

	if (entry) {
		return entry[1];
	}

	return value?.trim() ?? '';
};

export const walletFingerprint = (value?: string | null) => {
	const canonical = canonicalWalletName(value);
	if (!canonical) {
		return '';
	}

	return canonical.toLowerCase().replace(/[^a-z0-9]/g, '');
};
